import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import conciergeApiClient from 'Services/Apis/Concierge/conciergeApiClient';

export const uploadFileThunk = createAsyncThunk(
    `UploadFileSlicer/uploadFileThunk`,
    async (formData, { getState }) => {
        const { user } = getState().oidc;

        const headers = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            participantId: user.profile['custom:participant_id'],
            username: user.profile.username || user.profile['custom:login'],
            'Content-Type': 'multipart/form-data',
        };

        const { data } = await conciergeApiClient.post(
            "/RedemptionFile/UploadFile",
            formData,
            {
                headers
            }
        );
        return data;
    }
);

const initialState = {
    dataUploadFile: "",
    loadingUploadFile: false,
    errorUploadFile: false,
};

const UploadFileSlicer = createSlice({
    name: 'UploadFile',
    initialState,
    reducers: {
        resetDataUploadFile: (state) => {
            state.dataUploadFile = "";
            state.loadingUploadFile = false;
            state.errorUploadFile = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(uploadFileThunk.pending, (state) => {
            state.dataUploadFile = "";
            state.loadingUploadFile = true;
            state.errorUploadFile = false;
        });
        builder.addCase(uploadFileThunk.fulfilled, (state, action) => {
            state.dataUploadFile = action.payload;
            state.loadingUploadFile = false;
            state.errorUploadFile = false;
        });
        builder.addCase(uploadFileThunk.rejected, (state) => {
            state.dataUploadFile = "";
            state.loadingUploadFile = false;
            state.errorUploadFile = true;
        });
    },
});

export const { resetDataUploadFile } = UploadFileSlicer.actions;
export default UploadFileSlicer.reducer;